import { render } from "./usage.vue?vue&type=template&id=480ed068"
import script from "./usage.vue?vue&type=script&lang=js"
export * from "./usage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__